import { takeLatest, delay } from "redux-saga";
import { call, put, select, fork } from "redux-saga/effects";

import { ALL_CHANGE_ACTIONS, VALIDATE_EMPLOYEE_PROFILE, validateEmployeeProfile, updateOverallErrorMessage } from "./Actions";
import { overallError } from "./Selectors";

export function* watchValidateEmployeeProfile() {
  yield takeLatest(VALIDATE_EMPLOYEE_PROFILE, function* () {
    yield call(delay, 850);
    const errorMessage = yield select(overallError);
    yield put(updateOverallErrorMessage(errorMessage));
  });
}
// If the App needs the OverallErrorMessage to show up, this Saga
// needs to be added to the store, and the App is responsible
// for dispatching the validateEmployeeProfile action.
export function* EmployeeProfileSaga() {
  yield [fork(watchValidateEmployeeProfile)];
}
// Helper Saga that can be added in apps that want to auto validate
// the employee_profile when it changes.
export function* validateOnChange() {
  yield takeLatest(ALL_CHANGE_ACTIONS, function* () {
    yield put(validateEmployeeProfile());
  });
}
